import React from 'react'
import PropTypes from 'prop-types'
import BlockTitle from '@components/BlockTitle'
import { indexMap } from '@helpers'
import './TechSpecTable.module.scss'

const TechSpecTable = ({ headings, links, rows, slug }) => {
  const numCols = headings.length
  const colWidthPercentage = 100 / numCols
  const pos = links.indexOf(slug) + 1
  const selectedStyle = {
    left: `calc(${pos * colWidthPercentage}% - 1rem)`,
    width: `calc(${colWidthPercentage}% - 1rem)`
  }
  const title = links.length > 1 ? 'Compare Technical Specifications' : 'Technical Specifications'

  return (
    <div>
      <BlockTitle title={title} size='medium' background='blue' />
      <div styleName='table'>
        <div
          styleName={links.length > 1 ? 'selected' : ''}
          style={selectedStyle}
        />
        <div styleName='heading'>
          {indexMap((heading, index) => (
            <div styleName='cell' key={index}>
              {heading && <span>{heading}</span>}
            </div>
          ), headings)}
        </div>
        {indexMap((row, index) => (
          <div styleName='row' key={index}>
            {indexMap((cell, index) => (
              <div styleName='cell' key={index}>
                {cell}
              </div>
            ), row)}
          </div>
        ), rows)}
      </div>
    </div>
  )
}

TechSpecTable.propTypes = {
  headings: PropTypes.array,
  links: PropTypes.array,
  rows: PropTypes.array,
  slug: PropTypes.string.isRequired
}

TechSpecTable.defaultProps = {
  headings: [],
  links: [],
  rows: []
}

export default TechSpecTable



// WEBPACK FOOTER //
// ./src/components/TechSpecTable/TechSpecTable.js